import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss'],
  standalone: false
})
export class PageNotFoundComponent {}
